export type AnlagenTab = 'pruefen' | 'bestand' | 'wissen';
export type Entscheidung = 'anlage' | 'kein_anlagegut' | 'umbuchung' | 'zurueckgestellt';
export type EinordnungsArt = 'sofortaufwand' | 'gwg' | 'sammelposten' | 'anlagevermoegen';

export interface Hinweis {
  art: 'frage' | 'info';
  titel: string;
  text: string;
}

export interface Einordnung {
  art: EinordnungsArt;
  menge: number;
  selbststaendigNutzbar: boolean;
  einzelnBewerten: boolean;
  gesamt: { brutto: number; netto: number; ust: number };
  brutto: number;
  netto: number;
  ust: number;
  bemessungsgrundlage: number;
  aktivierungssumme: number;
  begruendung: string;
  hinweise: Hinweis[];
  sammelpostenMoeglich: boolean;
}

export interface Kandidat {
  id: number;
  datum: string;
  buchungstag: string;
  brutto: number;
  verwendungszweck: string | null;
  name_zahlungsbeteiligter: string | null;
  konto: string | null;
  kategorien: string | null;
  beleg_namen?: string | null;
  belege: number;
  entscheidung: string | null;
  einordnung: Einordnung;
  heuristik: { vorschlag: string | null; vertrauen: string; warum: string };
}

export interface KatalogEintrag {
  key: string;
  label: string;
  beispiele: string;
  jahre: number;
  geprueft: boolean;
  quelle: string;
}

export interface AfaZeile {
  jahr: number;
  afa: number;
  kumuliert: number;
  restbuchwert: number;
}

export interface Laufzeit {
  ende_jahr: number;
  ende_monat: number;
  restmonate: number;
  restjahre: number;
  fortschritt_prozent: number;
  abgeschlossen: boolean;
  abgegangen: boolean;
}

export interface VerknuepfteBuchung {
  id: number;
  datum: string;
  betrag: number;
  verwendungszweck: string | null;
  name_zahlungsbeteiligter: string | null;
  belege: number;
}

export interface Anlage {
  id: number;
  bezeichnung: string;
  kategorie: string;
  sphaere: string;
  menge: number;
  inbetriebnahme: string;
  anschaffungskosten: number;
  gesamtkosten: number;
  nutzungsdauer: number;
  art: string;
  restbuchwert: number;
  abgang: string | null;
  altbestand: number;
  laufzeit: Laufzeit | null;
  afa_plan: AfaZeile[];
  buchungen?: VerknuepfteBuchung[];
  standort?: string | null;
  beschreibung?: string | null;
  nutzungsdauer_quelle?: string | null;
  wert_geschaetzt?: number;
  ust_satz?: number;
  brutto?: number | null;
}

export interface Status {
  gesamt: number;
  offen: number;
  als_anlage: number;
  kein_anlagegut: number;
  umbuchung: number;
  schwelle_netto: number;
  schwelle_brutto: number;
  anlagen_im_bestand: number;
}

export interface AnlagenForm {
  bezeichnung: string;
  kategorie: string;
  sphaere: string;
  menge: number;
  selbststaendig_nutzbar: boolean;
  ust_satz: number;
  nutzungsdauer: number;
  inbetriebnahme: string;
  standort: string;
  notiz: string;
}

export interface KiErklaerung {
  quelle: 'ki' | 'regelwerk';
  belege_analysiert?: number;
  empfehlung: 'anlage' | 'kein_anlagegut' | 'umbuchung' | 'unklar';
  sicherheit: number;
  kurzfassung: string;
  erklaerung: string;
  gruende: string[];
  prueffragen: string[];
  vorgeschlagene_bezeichnung: string | null;
  vorgeschlagene_kategorie: string | null;
  vorgeschlagene_nutzungsdauer: number | null;
  hinweis?: string;
}

export interface BuchungDetail {
  id: number;
  datum: string;
  betrag: number;
  verwendungszweck: string | null;
  buchungstext: string | null;
  name_zahlungsbeteiligter: string | null;
  konto: string | null;
  kontotyp: string | null;
  von_konto: string | null;
  nach_konto: string | null;
  ist_umbuchung: boolean;
  kategorien: { name: string; betrag: number }[];
  nicht_kategorisiert: number;
  belege: { id: number; name: string; file_path?: string }[];
  pruefung: { entscheidung: string; notiz: string | null; anlage_bezeichnung: string | null } | null;
  anlagen: { id: number; bezeichnung: string }[];
}

export const SPHAEREN = [
  { key: 'ideell', label: 'Ideeller Bereich', hilfe: 'z. B. allgemeine Vereinsarbeit' },
  { key: 'zweck', label: 'Zweckbetrieb', hilfe: 'z. B. satzungsgemäßer Sportbetrieb' },
  { key: 'wirtschaftlich', label: 'Wirtschaftlicher Geschäftsbetrieb', hilfe: 'z. B. Kantine oder Verkauf' },
  { key: 'vermoegen', label: 'Vermögensverwaltung', hilfe: 'z. B. Vermietung oder Kapitalanlage' }
];

export const ART_LABEL: Record<string, string> = {
  sofortaufwand: 'Sofort als Aufwand',
  gwg: 'Geringwertiges Wirtschaftsgut',
  sammelposten: 'Sammelposten',
  anlagevermoegen: 'Ins Anlagenverzeichnis'
};

